module.exports = __webpack_public_path__ + "8ae798b63f6a2885ea8aa893c0a8048c.fbx";